import styled from "styled-components";

export const Wrap = styled.div``;

Wrap.Register = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #0263df;
  padding: 70px 0;
`;

Wrap.Title = styled.h2`
  font-weight: 600;
  font-size: 30px;
  line-height: 38px;
  color: #ffffff;
`;

Wrap.Des = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #ffffff;
  padding: 15px 0 30px 0;
`;

Wrap.Button = styled.div`
  background: #ffffff;
  border-radius: 3px;
  padding: 19px 50px;
  height: 55px;
  cursor: pointer;
  font-weight: 600;
  font-size: 13px;
  line-height: 17px;
  text-transform: uppercase;
  color: #0061df;
`;
